import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AuthCallbackPage } from '@/features/auth/callback-page';

const searchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute('/auth/callback')({
  validateSearch: searchSchema,
  component: AuthCallbackPage,
});
